// Contrôle d'accès de l'audioguide par jeton (token).
//
// Les cartes NFC encodent une URL du type :  /visite/ile-01?k=<ACCESS_TOKEN>
// À l'ouverture, le token est mémorisé sur le téléphone (localStorage) puis
// retiré de l'URL. Ensuite l'accès reste accordé sans token dans l'URL.
//
// ⚠️ ACCESS_TOKEN doit correspondre EXACTEMENT à ce que M. Boyau encode sur les
//    cartes (voir cartes-nfc.csv). Clé aléatoire (128 bits) ; pour la changer,
//    régénérer puis relancer `node scripts/build-cards-csv.mjs` et ré-encoder les cartes.
export const ACCESS_TOKEN = '6XG9VNmAnmIQ8VBghJr6ag';
export const ACCESS_PARAM = 'k';
export const ACCESS_STORAGE_KEY = 'visiteAccess';
